<template>
  <v-dialog
    width="600"
    persistent
    :value="enable">
    <v-card
      class="main--text">
      <v-container
        fluid>
        <v-row
          align=center
          no-gutters
          style="margin:0px 0px 20px 0px">
          <v-col><span class="font-weight-bold" style="font-size:1.3rem">授業結果編集画面</span>
          </v-col>
            <v-icon
              @click="$emit('close-button-click')">mdi-close</v-icon>
        </v-row>
        <h5>対象の先生</h5>
        <v-row>
          <v-col
            md8
            class="font-weight-bold">
            <v-avatar>
              <img :src="teacher.iconUrl" alt="">
            </v-avatar>
            {{ teacher.fullName() }} 先生
            </v-col>
        </v-row>
        <h5>対象のお子さま</h5>
        <p style="font-size:1.3rem">{{ student.fullName() }} さん</p>
        <v-row
          no-gutters>
          <v-col
            md=6>
            <v-menu
              ref="dateMenu"
              v-model="dateMenu"
              :close-on-content-click="false"
              :return-value.sync="stringDate">
              <template v-slot:activator="{ on }">
                <v-text-field
                  v-model="stringDate"
                  label="授業実施日"
                  prepend-icon="event"
                  v-on="on"
                  v-validate="'required'"
                  data-vv-name="stringDate"
                  data-vv-as="授業実施日"
                  required
                  :error-messages="errors.collect('stringDate')"
                  >
                </v-text-field>
              </template>
              <v-date-picker
                v-model="stringDate"
                no-title
                scrollable
                width="360">
                <v-spacer></v-spacer>
                <v-btn text color="primary" @click="dateMenu = false">Cancel</v-btn>
                <v-btn text color="primary" @click="$refs.dateMenu.save(stringDate)">OK</v-btn>
              </v-date-picker>
            </v-menu>
          </v-col>
        </v-row>
        <v-lesson-editor
          v-model="lesson"/>
      <v-btn
        depressed
        outlined
        rounded
        @click="update">
        確定
      </v-btn>
      </v-container>
    </v-card>
  </v-dialog>
</template>

<script>
import VLessonEditor from '@/components/organisms/parent/VLessonEditor'

export default {
  components: {
    VLessonEditor
  },
  props: {
    value: Object,
    teacher: Object,
    student: Object,
    enable: Boolean
  },
  data () {
    return {
      dateMenu: null
    }
  },
  methods: {
    update () {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.$emit('update-button-click')
          this.dialog = true
        }
      })
    },
    updateValue(diff) {
      this.$emit('input', { ...this.value, ...diff })
    },
    dateToString() {
      const t = this.value.date.getFullYear()
      const m = this.value.date.getMonth() + 1
      const d = this.value.date.getDate()
      return t + "-" + m + "-" + d
    },
  },
  computed: {
    stringDate: {
      get() {
        return this.dateToString()
      },
      set(stringDate) {
        const date = new Date(stringDate)
        this.updateValue({ date })
      }
    },
    lesson: {
      get() {
        return this.value.lesson
      },
      set(lesson) {
        this.updateValue({ lesson })
      }
    }
  }
}
</script>
